import { IClassname } from '@/lib/shared/model/classname';

export const HomeCinema = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14444_625)">
        <path
          d="M30.696 15.3608V3.85954C30.696 2.448 29.5518 1.30371 28.1402 1.30371H3.85979C2.44824 1.30371 1.30396 2.448 1.30396 3.85954V15.3608C1.30396 16.7724 2.44824 17.9166 3.85979 17.9166H28.1402C29.5518 17.9166 30.696 16.7724 30.696 15.3608Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.5845 1.30371V17.9166"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.41553 1.30371V17.9166"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 6.41602H6.41562"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 12.8057H6.41562"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.5845 6.41602H30.6961"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.5845 12.8057H30.6961"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7283 10.8013C20.9683 10.708 21.1745 10.5443 21.3199 10.3318C21.4653 10.1193 21.543 9.86779 21.543 9.61029C21.543 9.3528 21.4653 9.1013 21.3199 8.88877C21.1745 8.67626 20.9683 8.51261 20.7283 8.41927L12.3976 5.18103C12.3008 5.14343 12.1963 5.13 12.0931 5.14191C11.9899 5.15381 11.8912 5.19067 11.8055 5.24933C11.7197 5.30799 11.6496 5.38666 11.6012 5.47851C11.5527 5.57038 11.5274 5.67268 11.5273 5.77654V13.444C11.5274 13.5479 11.5527 13.6502 11.6012 13.742C11.6496 13.8339 11.7197 13.9126 11.8055 13.9713C11.8912 14.03 11.9899 14.0668 12.0931 14.0786C12.1963 14.0905 12.3008 14.0771 12.3976 14.0395L20.7283 10.8013Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.20212 26.8622C7.96655 26.8622 9.39691 25.4319 9.39691 23.6674C9.39691 21.903 7.96655 20.4727 6.20212 20.4727C4.43768 20.4727 3.00732 21.903 3.00732 23.6674C3.00732 25.4319 4.43768 26.8622 6.20212 26.8622Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.7978 26.8622C27.5622 26.8622 28.9926 25.4319 28.9926 23.6674C28.9926 21.903 27.5622 20.4727 25.7978 20.4727C24.0334 20.4727 22.603 21.903 22.603 23.6674C22.603 25.4319 24.0334 26.8622 25.7978 26.8622Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 26.8622C17.7644 26.8622 19.1948 25.4319 19.1948 23.6674C19.1948 21.903 17.7644 20.4727 16 20.4727C14.2355 20.4727 12.8052 21.903 12.8052 23.6674C12.8052 25.4319 14.2355 26.8622 16 26.8622Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 30.6964C1.84205 29.8953 2.57224 29.2416 3.42785 28.7952C4.28347 28.3487 5.23727 28.1237 6.20221 28.1406C7.16737 28.1234 8.12142 28.3485 8.97728 28.7949C9.83314 29.2414 10.5635 29.895 11.1017 30.6964C11.6397 29.8951 12.3698 29.2414 13.2255 28.7949C14.0811 28.3483 15.035 28.1234 16 28.1406C16.965 28.1234 17.9189 28.3483 18.7745 28.7949C19.6302 29.2414 20.3604 29.8951 20.8983 30.6964C21.4487 29.9074 22.1814 29.263 23.0344 28.818C23.8873 28.373 24.8351 28.1407 25.7971 28.1407C26.7592 28.1407 27.707 28.373 28.5599 28.818C29.4129 29.263 30.1456 29.9074 30.696 30.6964"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14444_625">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
